import { createAction } from "redux-actions";
import { SsrConstants } from "../constants";

/**
 * Dispatches an update to the isSSR flag on the app state root object
 */
export const updateIsSsrFlag = createAction<boolean, boolean>(
    SsrConstants.IS_SSR, (isSSR) => (isSSR),
);



// WEBPACK FOOTER //
// ./src/actions/AppStore.ts